module.exports = __webpack_public_path__ + "img/et.0dc00578.svg";